import { TextAreaProps } from "./types";

const TextArea: React.FC<TextAreaProps> = ({
  label,
  name,
  id,
  required,
  disabled,
  placeholder,
  autoComplete,
  value,
  error,
  errorMessage,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  onLeftIconClick,
  onRightIconClick,
  onChange,
  onBlur,
  onKeyDown,
  onPaste,
  containerClassName = "",
  secondaryContainerClassName = "",
  textAreaClassName = "",
  iconClassName = "",
  labelClassName = "",
  errorClassName = "",
  rows = 4,
}) => {
  const textAreaId =
    id || name || `textarea-${Math.random().toString(36).slice(2, 9)}`;
  const errorId = `${textAreaId}-error`;

  return (
    <div className={`flex flex-col space-y-1 ${containerClassName}`}>
      {label && (
        <label htmlFor={textAreaId} className={`${labelClassName}`}>
          {label}
          {required && <span>*</span>}
        </label>
      )}

      <div className={`${secondaryContainerClassName}`}>
        {LeftIcon && (
          <button
            type="button"
            aria-label="left icon button"
            onClick={onLeftIconClick}
            className={`shrink-0 ${iconClassName}`}
          >
            <LeftIcon />
          </button>
        )}

        <textarea
          id={textAreaId}
          name={name}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          value={value}
          autoComplete={autoComplete}
          rows={rows}
          onChange={onChange}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          onPaste={onPaste}
          aria-invalid={error ? "true" : "false"}
          aria-describedby={error && errorMessage ? errorId : undefined}
          className={`w-full resize-none bg-transparent outline-none flex-1 border-none font-normal text-md text-heading-text dark:text-heading-text-dk placeholder:text-gray-placeholder dark:placeholder:text-gray-placeholder placeholder:font-normal placeholder:text-md  ${textAreaClassName}`}
        />

        {RightIcon && (
          <button
            type="button"
            aria-label="right icon button"
            onClick={onRightIconClick}
            className={`shrink-0 ${iconClassName}`}
          >
            <RightIcon />
          </button>
        )}
      </div>

      {error && errorMessage && (
        <div
          id={errorId}
          role="alert"
          className={`text-xxs text-verba-red-alert dark:text-verba-red-alert-dk ${errorClassName}`}
        >
          <span>{errorMessage}</span>
        </div>
      )}
    </div>
  );
};

export default TextArea;
